import { authors } from '../data/authors'
import AuthorAvatar from './AuthorAvatar'

export default function Authors() {
  return (
    <section className="wrap sec" id="authors">
      <div className="sec-head">
        <div>
          <div className="idx">
            THE FIELD TEAM &middot; <b>4 CONTRIBUTORS</b>
          </div>
          <h2>Who Writes This</h2>
        </div>
      </div>
      <p className="authors-note">
        Our contributors write under consistent field names rather than full identities, standard practice in this community, and one
        we follow deliberately. Real expertise, anonymized presentation.
      </p>
      <div className="authors-grid">
        {authors.map((a) => (
          <div className="author-card" id={a.slug} key={a.slug}>
            <AuthorAvatar author={a} size={64} />
            <div className="author-info">
              <h3>{a.name}</h3>
              <div className="author-meta">
                {a.age} &middot; {a.location}
              </div>
              <div className="author-role">{a.role}</div>
              <p className="author-bio">{a.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
